'use client';

import { memo } from 'react';

import { useTranslations } from 'next-intl';

import { Button } from '@/components/ui/button';

interface I_FormActionsProps {
  isSaving: boolean;
  hasChanges: boolean;
  onSaveChanges: () => void;
  onDeleteClick: () => void;
}

const FormActions = memo(function FormActions({
  isSaving,
  hasChanges,
  onSaveChanges,
  onDeleteClick
}: I_FormActionsProps) {
  const t = useTranslations('editProfile');

  return (
    <div className="grid gap-4 w-full">
      <Button
        onClick={onSaveChanges}
        className="h-9"
        disabled={isSaving || !hasChanges}
      >
        {isSaving ? 'Saving...' : t('form.saveChanges')}
      </Button>
      <Button className="h-9" variant={'destructive'} onClick={onDeleteClick}>
        {t('form.deleteAccount')}
      </Button>
    </div>
  );
});

export default FormActions;
